import React from "react"

import {
    Button,
    Grid,
    H2,
    Paragraph,
    Picture,
    Section,
    Stage,
    Spinner,
    Theme
} from "@lsg/components";
import {connect} from "react-redux";
import {Page} from "../Page/Page";

class FourPartPage extends Page {

    constructor(props) {
        super(props);
        const query = `query ReadOneFourPartPage($Locale: Locale, $Filter: FourPartPageFilterFields){
  readOneFourPartPage(locale: $Locale, filter: $Filter) {
      title,
      heroImage {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part1Title,
      content,
      part1Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part2Title,
      part2Text,
      part2Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part3Title,
      part3Text,
      part3Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
      part4Title,
      part4Text,
      part4Image {
        ...on Image{
          fileFilename,
          absoluteLink
        }
      },
}
}`;

        this.state = {
            ...this.state,
            pageData: {
                heroImage: {
                    absoluteLink: 'header_home-min.png'
                }
            },
            query,
            filters: null
        };
    }

    render() {
        const isLoaded = this.state.loaded;
        if (isLoaded) {
            return (
                <>
                    <Stage
                        theme={Stage.Themes.DARK}
                        headline={this.state.pageData.title}
                        scrollerText={this.state.scrollerText[this.props.lang.lang.label]}
                        backgroundImageImgSrc={this.state.pageData.heroImage.absoluteLink}
                    />
                    <Section>
                        <Grid.Row>
                            <Grid.Column size={6}>
                                <H2>{this.state.pageData.part1Title}</H2>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column size={6}>
                                <Paragraph>
                                    {this.formatText(this.state.pageData.content)}
                                </Paragraph>
                            </Grid.Column>
                            <Grid.Column size={6}>
                                <Picture imgSrc={this.state.pageData.part1Image.absoluteLink}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Section>
                    <Theme look={Theme.Dark} className="elevated-section-theme">
                        <Section className="elevated-section" id="section-1">
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column size={6} />
                                    <Grid.Column size={6}>
                                        <H2>{this.state.pageData.part2Title}</H2>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column size={6}>
                                        <Picture className="elevated-image" imgSrc={this.state.pageData.part2Image.absoluteLink}/>
                                    </Grid.Column>
                                    <Grid.Column size={6}>
                                        {this.formatText(this.state.pageData.part2Text)}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Section>
                    </Theme>
                    <Section>
                        <Grid.Row>
                            <Grid.Column size={6}>
                                <H2>{this.state.pageData.part3Title}</H2>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column size={6}>
                                <Paragraph>
                                    {this.formatText(this.state.pageData.part3Text)}
                                </Paragraph>
                            </Grid.Column>
                            <Grid.Column size={6}>
                                <Picture imgSrc={this.state.pageData.part3Image.absoluteLink}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Section>
                    <Theme look={Theme.Dark} className="elevated-section-theme">
                        <Section className="elevated-section" id="section-4">
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column size={6} />
                                    <Grid.Column size={6}>
                                        <H2>{this.state.pageData.part4Title}</H2>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column size={6}>
                                        <Picture className="elevated-image" imgSrc={this.state.pageData.part4Image.absoluteLink}/>
                                    </Grid.Column>
                                    <Grid.Column size={6}>
                                        {this.formatText(this.state.pageData.part4Text)}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Section>
                    </Theme>
                </>
            );
        }
        return (
            <Section className="page-loader">
                <Grid>
                    <Grid.Row>
                        <Grid.Column size={12} horizontalAlign={Grid.HorizontalAlign.CENTER}>
                            <Spinner/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Section>
        );

    }
}

// export default NewsPage
function mapStateToProps(state) {
    return {lang: state.lang}
}

export default connect(mapStateToProps)(FourPartPage)
